import classNames from 'classnames'

import { OrderUnitCard, OrderUnitCardSkeleton } from '@apps-common/apps/portal/pages/orders/pages/details/components'
import { CardContainer } from '@apps-common/components/common'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { sortAlphabetically } from '@apps-common/helpers/array-sort'
import { IOrderDetailsModel } from '@apps-common/types/portal/order'

interface IProps {
  data?: IOrderDetailsModel
  loading: boolean
  updating: boolean
  classes?: string
}

export const PortalOrderUnits: React.FC<IProps> = ({ data, loading, updating, classes }) => {
  const { units } = data || {}

  return (
    <CardContainer
      bgClasses={classNames('lg:absolute bg-surface border border-border overflow-hidden !h-[100%] flex flex-col !pb-0', classes)}
    >
      <div className='absolute z-[10] top-0 left-0 px-6 py-4 w-full rounded-t-3xl backdrop-blur-md flex items-center justify-between'>
        <SectionTitle classes='text-text' text='Devices' />
      </div>
      {loading && (
        <div className='grid md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-[20px] overflow-y-auto overflow-x-hidden scrollbar-none pt-[40px] pb-6'>
          {Array.from(Array(8).keys()).map((k) => (
            <div key={`order-unit-skeleton-${k}`}>
              <OrderUnitCardSkeleton />
            </div>
          ))}
        </div>
      )}
      {!loading && (
        <>
          {units && units?.length === 0 && (
            <div className='flex flex-col gap-[20px] grow pt-[40px] pb-6'>
              {(!units || units?.length === 0) && (
                <div className='flex flex-col items-left justify-center gap-[5px] bg-surface-2 text-text border border-border rounded-3xl p-6'>
                  <div className='jost-medium'>No devices</div>
                  <div className='jost-light'>There are no devices associated with this order</div>
                </div>
              )}
            </div>
          )}
          {units && units?.length > 0 && (
            <div className='grid md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-[20px] overflow-y-auto overflow-x-hidden scrollbar-none pt-[40px] pb-6'>
              {units &&
                units?.length > 0 &&
                units
                  .sort((a, b) => sortAlphabetically(a, b, 'status'))
                  .map((u, i) => <OrderUnitCard index={i} loading={loading} updating={updating} unit={u} />)}
            </div>
          )}
        </>
      )}
    </CardContainer>
  )
}
